export const jp = {
  // TopBarHeader
  '连接状态': '接続状態',
  'MCU连接状态': 'MCU状態',
  'Hamlib: Connected': 'Hamlib: Connected',
  'MUC: 未连接': 'MUC: 未接続',
  'Connected': '接続済み',
  'Disconnected': '未接続',
  '输出天线：': '出力アンテナ: ',
  '手动选择': '手動',
  '自动选择': '自動',
  '触发模式：': 'トリガーモード: ',
  '接收状态': '受信',
  'PPT1': 'PPT1',
  'PPT2': 'PPT2',
  '输入功率触发': '入力電力',
  '时间': '時間',
  '系统同步': 'システム同期',
  '报警信息': 'アラーム',

  // TopBarBottom
  '输入天线1': '入力アンテナ1',
  '输入天线2': '入力アンテナ2',
  '输入天线衰减器': '入力減衰器',
  '输入衰减器': '入力減衰器',
  '功放': 'アンプ',
  '天调': 'チューナー',
  '关闭': 'オフ',
  '开启': 'オン',
  '调谐中': 'チューニング中',
  '调谐失败': 'チューニング失敗',
  '输出天线1': '出力アンテナ1',
  '输出天线2': '出力アンテナ2',
  '输出天线3': '出力アンテナ3',
  '输出天线4': '出力アンテナ4',

  // TopBarMiddle
  '频段未获取': '周波数未取得',
  'Counter': 'カウンター',
  'Hamlib': 'Hamlib',
  '滤波器：': 'フィルター: ',
  '频段：': 'バンド: ',
  '输入': '入力',
  '输出': '出力',
  '反向功率': '逆電力',
  '驻波': 'SWR',
  '电压:': '電圧:',
  '电流:': '電流:',
  '功率:': '電力:',
  '温度:': '温度:'
};
